import React, { forwardRef } from "react";
import StyledTypography, { StyledRequiredSymbol } from "./Typography.styles";
import { TypographyProps } from "./Typography.types";

const Typography = forwardRef<HTMLElement, TypographyProps>(
    (props: TypographyProps, ref) => {
        const { children, as = "span", ...restProps } = props;

        if (!children) return null;

        return (
            <StyledTypography {...restProps} as={as} ref={ref}>
                {children}
                {props?.required ? (
                    <StyledRequiredSymbol>*</StyledRequiredSymbol>
                ) : null}
            </StyledTypography>
        );
    },
);

export default Typography;
